<template>
  <div class="page-card">
    <h2 class="page-title">权限配置</h2>
    <el-alert
      title="当前页面沿用系统现有权限结构，只做展示优化，不调整角色与权限模型。"
      type="info"
      :closable="false"
      style="margin-bottom: 16px"
    />
    <el-table
      :data="flatList"
      border
      row-key="id"
      default-expand-all
      :tree-props="{ children: 'children' }"
    >
      <el-table-column label="权限名称" min-width="240">
        <template slot-scope="{ row }">
          <div class="permission-name-cell">
            <span>{{ row.permissionName }}</span>
            <el-tag size="mini" :type="row.permissionType === 1 ? 'success' : row.permissionType === 2 ? 'warning' : 'info'">
              {{ permissionTypeText(row.permissionType) }}
            </el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="permissionCode" label="权限标识" min-width="220" />
      <el-table-column prop="moduleCode" label="模块编码" min-width="160" />
      <el-table-column prop="routePath" label="路由地址" min-width="220" />
      <el-table-column label="状态" width="120">
        <template slot-scope="{ row }">
          <el-tag :type="row.permissionStatus === 1 ? 'success' : 'info'">
            {{ row.permissionStatus === 1 ? '启用' : '停用' }}
          </el-tag>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getPermissionTree } from '../../../api/adminPermission'

export default {
  name: 'PermissionPage',
  data() {
    return {
      tree: []
    }
  },
  computed: {
    flatList() {
      return this.tree
    }
  },
  async created() {
    this.tree = await getPermissionTree()
  },
  methods: {
    permissionTypeText(type) {
      if (type === 1) return '菜单'
      if (type === 2) return '页面'
      if (type === 3) return '按钮'
      return '未知'
    }
  }
}
</script>

<style scoped>
.permission-name-cell {
  display: flex;
  align-items: center;
  gap: 10px;
}
</style>
